module.exports = __webpack_public_path__ + "static/media/logo1.4a90ad67.png";